import { CS_NUMBER, DEFAULT_WHATSAPP_MESSAGE } from "@/constants";
import { handleWhatsappNumber } from "../platform";
import { sendAnalyticData } from "../monitoring/analytics";
import { embedTrackingUrl } from "../monitoring/oci";
import type { ServiceName } from "@/types/service";
import { getServiceLabel } from "../service/helpers";

export const onChatSales = (
  includeTrackingUrl = false,
  message = DEFAULT_WHATSAPP_MESSAGE,
) => {
  if (includeTrackingUrl) {
    message = embedTrackingUrl(message);
  }

  handleWhatsappNumber(CS_NUMBER, message);
  sendAnalyticData({
    name: "wa_sales_button_click",
  });
};

export const generateBookingChatSalesMessage = (service: ServiceName) => {
  return `Hi, I would like to chat about your ${getServiceLabel(service)} on your page https://app.luce.com/booking/${service}`;
};
